import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  ValidationErrors,
  FormBuilder,
} from '@angular/forms';
import { Beneficiaire, BeneficiaireRequest, EmployeeInput, EmployeeValidationResult } from 'src/app/models/beneficiaire';
import { BeneficiaireService } from 'src/app/services/beneficiaire.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { ModalField, ModalComponent } from 'src/app/modal/modal.component';
import { TicketService } from 'src/app/services/ticket.service';
import { Router } from '@angular/router';
import { LinkMappingTool } from 'src/app/enums/mapping';
import { forkJoin, map, switchMap } from 'rxjs';
import { SoldeService } from 'src/app/services/solde.service';
import { Balance } from 'src/app/models/balance';
import { RoutesEnum } from 'src/app/enums/routes-enum';
import { LocalDataSource } from 'angular2-smart-table';
import { CustomActionComponent } from '../custom-action/custom-action.component';
import * as Papa from 'papaparse';




// Declare Flowbite Modal interface/class for TypeScript
declare var Modal: {
  new (targetEl: HTMLElement | null, options?: any): {
    hide(): void;
    // You might need to add other methods like show(), toggle() if you use them
  };
};

declare var initFlowbite: () => void;

const tableHeaders = {
  lastName: 'Nom',
  firstName: 'Prénom',
  phoneNumber: 'Téléphone',
  email: 'Email',
  role: 'Role',
  status: 'Statut',
  actions: 'Actions',
};

@Component({
  selector: 'app-beneficiaire',
  templateUrl: './beneficiaire.component.html',
  styleUrls: ['../../marchand/shared/tx-table.css', './beneficiaire.component.css'],
  providers: [MessageService],
})
export class BeneficiaireComponent implements OnInit, AfterViewInit {
  selectedRows: any[] = [];
  data: Beneficiaire[] = [];
  filteredData: LocalDataSource = new LocalDataSource();
  message!: string;
  settings: any;
  chargeModalId: string = 'charge-modal';
  deleteModalId: string = 'delete-modal';
  ticketAmount: number = 0; // Default value
  amounToTransfer: number = 0;
  isMulti: boolean = false;
  id: string | null = '';
  beneficiaire: BeneficiaireRequest | undefined;
  label: any;
  idTicket!: number;
  balance: any;
  errorBalance: boolean = false;
  errorBalanceMessage: string = 'Votre solde est insuffisant !';
  amountLabel: string = 'Nombre de jours';
  importCsvModalId: string = 'import-csv-modal';
  addBeneficiaireModalId: string = 'add-beneficiaire-modal';
  validationResults: EmployeeValidationResult[] = [];
  isUploading = false;
  isDeleting = false;
    // --- Tableau ---
  searchQuery = '';
  checkedRows: any[] = [];
  tablePage = 1;
  readonly tablePageSize = 10;
  csvFileName = '';
  isDragging = false;

currentPage = 1;
itemsPerPage = 10;
totalCount = 0;
validCount = 0;
invalidCount = 0;
canSendToBack = false;

  beneficiaireFields: ModalField[] = [
    {
      controlName: 'lastName',
      label: 'Nom',
      type: 'text',
      placeholder: 'Nom de famille',
      required: true,
    },
    {
      controlName: 'firstName',
      label: 'Prénom',
      type: 'text',
      placeholder: 'Prénom',
      required: true,
    },
    {
      controlName: 'email',
      label: 'Email address',
      type: 'email',
      placeholder: 'Adresse email',
      required: true,
    },
    {
      controlName: 'phoneNumber',
      label: 'Téléphone',
      type: 'tel',
      placeholder: 'Numéro de téléphone',
      required: true,
    },
  ];
  chargeForm!: FormGroup;
  account!: string;
  companyId!: string;
  stayBalance: any;

  constructor(
    private beneficiaireService: BeneficiaireService,
    private sharedService: SharedServiceService,
    private messageService: MessageService,
    private authService: AuthService,
    private ticketService: TicketService,
    private router: Router,
    private soldeService: SoldeService,
    private fb: FormBuilder
  ) {
    // Subscribe to days changes
    this.chargeForm = this.fb.group({
      days: ['', [Validators.required, positiveNumberValidator]],
    });
    this.chargeForm.get('days')?.valueChanges.subscribe(() => {
      this.updateTotalAmount();
    });
  }

  ngOnInit(): void {
    this.loadUserCompanyId();
    this.loadTicketAmount();
    this.loadEmployes();
    this.subscribeToSharedMessage();
    this.updateSettings();
    this.loadTicketData();
    this.label = LinkMappingTool.getAvantageLabel(
      this.router.url.split('/')[2]
    );
    // this.beneficiaireForm = this.fb.group({
    //   lastName: ['', Validators.required],
    //   firstName: ['', Validators.required],
    //   email: ['', [Validators.required, Validators.email]],
    //   phoneNumber: ['', Validators.required],
    //   companyId: [this.id, Validators.required],
    // });
  }
  private loadTicketData(): void {
    this.ticketService.getAllTickets().subscribe((re) => {
      const tickets = Array.isArray(re.tickets) ? re.tickets : [];
      const ticket = tickets.find(
        (item: { label: string }) => item.label === this.label
      );
      if (ticket) {
        this.idTicket = ticket.id;
      }
    });
  }
  private loadUserCompanyId(): void {
    this.authService
      .getUser()
      .pipe(
        switchMap((user) => {
          if (user && user.sub && user.account) {
            // this.beneficiaireForm.get('companyId')?.setValue(user.sub || '');
            this.account = user.account;
            this.companyId = user.sub;
          } else {
            console.warn('Aucun compte trouvé.');
          }

          return this.ticketService.getAllTickets();
        }),
        switchMap((response) => {
          const tickets = Array.isArray(response.tickets)
            ? response.tickets
            : [];
          const balanceRequests = tickets.map(
            (ticket: { id: any; label: string }) =>
              this.soldeService
                .getBalance(ticket.id, this.account)
                .pipe(
                  map(
                    (balanceResponse) =>
                      new Balance(
                        ticket.label,
                        balanceResponse.result.balance,
                        new Date()
                      )
                  )
                )
          );
          return forkJoin<Balance[]>(balanceRequests);
        })
      )
      .subscribe(
        (balances) => {
          this.balance = balances.find(
            (item) => item.ticket === this.label
          )?.amount;
          this.stayBalance = this.balance;
        },
        (error) => {
          console.error('Erreur lors du chargement des soldes :', error);
        }
      );
  }

  private loadTicketAmount(): void {
    this.ticketService.getTicketAmount().subscribe({
      next: (res) => {
        this.ticketAmount = res?.data?.ticketAmount || 0;
        this.updateTotalAmount();
      },
      error: (err) =>
        this.logError(
          'Erreur lors de la récupération du montant des tickets',
          err
        ),
    });
  }
private loadEmployes(): void {


  this.beneficiaireService.getAllEmployes().subscribe({
    next: (res) => {


      this.data = res.result || res.employes || [];






      if (!this.filteredData) {
        this.filteredData = new LocalDataSource();
      }




      this.filteredData.load(this.data);
      this.checkedRows = [];

    },
    error: (err) => {
      console.error(' Erreur lors du chargement:', err);
      if (err.status == 401) {
        this.authService.logout();
        this.router.navigate([RoutesEnum.signinRoute]);
      }
      this.logError('Erreur lors de la récupération des employés', err);
    },
  });
}
  private subscribeToSharedMessage(): void {
    this.sharedService.currentMessage.subscribe({
      next: (message) => (this.message = message),
      error: (err) =>
        this.logError('Erreur lors de la récupération du message partagé', err),
    });
  }
  private logError(context: string, error: any): void {
    console.error(`${context}:`, error);
  }

  updateTotalAmount(): void {
    const days = parseInt(this.chargeForm.get('days')?.value || '0', 10);
    const label = this.router.url.split('/')[2];
    const isTitreRestaurant = label === 'titre-restaurant';

    // Déterminer le montant à transférer
    this.amountLabel = isTitreRestaurant
      ? this.amountLabel
      : 'Montant à envoyer';
    this.amounToTransfer = isTitreRestaurant
      ? this.selectedRows.length * days * this.ticketAmount
      : this.selectedRows.length * days;

    // Calcul du solde restant
    this.stayBalance = this.balance - this.amounToTransfer;

    // Gestion d'erreur de solde insuffisant
    if (this.stayBalance < 0) {
      this.errorBalance = true;
      this.showError(99);
      this.chargeForm.reset({ days: null });
    }
  }



get totalPages(): number {
  return Math.ceil(this.totalCount / this.itemsPerPage);
}

get startIndex(): number {
  return (this.currentPage - 1) * this.itemsPerPage;
}

get endIndex(): number {
  return Math.min(this.startIndex + this.itemsPerPage, this.totalCount);
}

get paginatedResults(): EmployeeValidationResult[] {
  return this.validationResults.slice(this.startIndex, this.endIndex);
}

get visiblePages(): number[] {
  const pages: number[] = [];
  const maxVisible = 5;


  let startPage = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
  let endPage = Math.min(this.totalPages, startPage + maxVisible - 1);


  if (endPage - startPage < maxVisible - 1) {
    startPage = Math.max(1, endPage - maxVisible + 1);
  }


  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }


  return pages;
}


goToPage(page: number): void {
  if (page >= 1 && page <= this.totalPages) {
    this.currentPage = page;
  }
}

nextPage(): void {
  if (this.currentPage < this.totalPages) {
    this.currentPage++;
  }
}

previousPage(): void {
  if (this.currentPage > 1) {
    this.currentPage--;
  }
}

onItemsPerPageChange(): void {
  this.currentPage = 1;
  this.currentPage = 1;
}



onCsvSelected(event: any) {
  const file: File = event.target.files[0];
  if (!file) return;
  this.parseCsvFile(file);
}

// ---------- Glisser-déposer ----------
onCsvDragOver(event: DragEvent): void {
  event.preventDefault();
  this.isDragging = true;
}

onCsvDragLeave(event: DragEvent): void {
  event.preventDefault();
  this.isDragging = false;
}

onCsvDrop(event: DragEvent): void {
  event.preventDefault();
  this.isDragging = false;
  const file = event.dataTransfer?.files?.[0];
  if (!file) return;
  if (!file.name.toLowerCase().endsWith('.csv')) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Format non supporté',
      detail: 'Veuillez déposer un fichier .csv',
    });
    return;
  }
  this.parseCsvFile(file);
}

/** Modèle CSV avec les colonnes attendues par l'import */
downloadCsvTemplate(): void {
  const content =
    'lastName,firstName,email,phoneNumber\n' +
    'Diop,Awa,awa.diop@exemple.com,771234567\n';
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'modele-beneficiaires.csv';
  link.click();
  URL.revokeObjectURL(url);
}

private parseCsvFile(file: File): void {
  this.csvFileName = file.name;

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: (results: Papa.ParseResult<EmployeeInput>) => {
      const rows: EmployeeInput[] = results.data;
      this.validationResults = [];
      this.totalCount = rows.length;
      this.currentPage = 1;
      this.currentPage = 1;

      const emailsSeen = new Set<string>();
      const phonesSeen = new Set<string>();

      rows.forEach((row: any, index: number) => {
        const employee: EmployeeInput = {
          firstName: (row.firstName || '').trim(),
          lastName: (row.lastName || '').trim(),
          email: (row.email || '').trim(),
          phoneNumber: (row.phoneNumber || '').trim(),
        };

        const errors: string[] = [];



        if (!employee.firstName) errors.push('Prénom requis');
        if (!employee.lastName) errors.push('Nom requis');
        if (!employee.email) errors.push('Email requis');
        if (!employee.phoneNumber) errors.push('Téléphone requis');



        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (employee.email && !emailRegex.test(employee.email)) {
          errors.push('Email invalide');
        }

        const phoneRegex = /^(\+221|00221)?(70|71|75|76|77|78)\d{7}$/;
        if (employee.phoneNumber && !phoneRegex.test(employee.phoneNumber)) {
          errors.push('Téléphone invalide (ex: +221771234567)');
        }

        if (employee.email && emailsSeen.has(employee.email.toLowerCase())) {
          errors.push('Email en double');
        } else if (employee.email) {
          emailsSeen.add(employee.email.toLowerCase());
        }



        if (employee.phoneNumber && phonesSeen.has(employee.phoneNumber)) {
          errors.push('Téléphone en double');
        } else if (employee.phoneNumber) {
          phonesSeen.add(employee.phoneNumber);
        }

        const validationResult: EmployeeValidationResult = {
          index,
          employee,
          isValid: errors.length === 0,
          errors,
        };

        this.validationResults.push(validationResult);
      });



      this.validCount = this.validationResults.filter(r => r.isValid).length;
      this.invalidCount = this.validationResults.filter(r => !r.isValid).length;
      this.canSendToBack = this.totalCount > 0 && this.invalidCount === 0;



    },
    error: (err: any) => {
      console.error('Erreur parsing CSV:', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Impossible de lire le fichier CSV',
      });
    }
  });
}

sendCsvToBack() {
  if (!this.canSendToBack) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Attention',
      detail: 'Veuillez corriger les erreurs avant d\'envoyer',
    });
    return;
  }

  this.isUploading = true;

  const validEmployees = this.validationResults
    .filter(r => r.isValid)
    .map(r => r.employee);

  this.beneficiaireService.bulkRegisterEmployees(this.companyId, validEmployees)
    .subscribe({
      next: (response: any) => {
        this.isUploading = false;

        const status = response?.status ?? 'success';
        const successCount = response?.successCount ?? response?.total ?? validEmployees.length;
        const failedCount = response?.failedCount ?? 0;
        const failedEmployees = response?.failedEmployees ?? [];


        if (response.status === 'success') {
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            //detail: `${response.summary.successCount} employé(s) enregistré(s) avec succès`,
            detail: `${successCount} employés enregistrés avec succès`,
          });


           this.closeImportCsvModal();
          setTimeout(() => this.loadEmployes(), 800);


        } else if (response.status === 'partial_success') {
          this.updateValidationResultsWithBackendErrors(response.failedEmployees || []);


          this.messageService.add({
            severity: 'warn',
            summary: 'Succès partiel',
            //detail: `${response.summary.successCount} réussis, ${response.summary.failedCount} échoués.`,
            detail: `${successCount} réussis, ${failedCount} échoués.`,
          });




          setTimeout(() => {
            this.loadEmployes();
          }, 800);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: response?.message ?? 'Une erreur est survenue',
          });
        }
      },
      error: (error) => {
        this.isUploading = false;
        //console.error('Erreur lors de l\'envoi:', error);

        let errorDetail = 'Erreur lors de l\'envoi des données';


        if (error.status === 401) {
          this.authService.logout();
          this.router.navigate([RoutesEnum.signinRoute]);
          errorDetail = 'Session expirée, veuillez vous reconnecter';
        } else if (error.status === 400) {
          errorDetail = 'Données invalides. Veuillez vérifier les informations';
        } else if (error.status === 500) {
          errorDetail = 'Erreur serveur. Veuillez réessayer plus tard';
        }


        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: errorDetail,
        });
      }
    });
}




private updateValidationResultsWithBackendErrors(failedEmployees: any[]): void {
  failedEmployees.forEach(failed => {
    const result = this.validationResults[failed.index];
    if (result) {
      result.isValid = false;
      // Ajouter les erreurs du backend aux erreurs existantes
      result.errors = [...new Set([...result.errors, ...failed.errors])];
    }
  });

  // Recalculer les compteurs
  this.validCount = this.validationResults.filter(r => r.isValid).length;
  this.invalidCount = this.validationResults.filter(r => !r.isValid).length;
  this.canSendToBack = this.invalidCount === 0 && this.validCount > 0;
}


private resetCsvImport(): void {
  this.validationResults = [];
  this.totalCount = 0;
  this.validCount = 0;
  this.invalidCount = 0;
  this.canSendToBack = false;
  this.currentPage = 1;


  this.csvFileName = '';
  this.isDragging = false;

  const fileInput = document.getElementById('csv-file-input') as HTMLInputElement | null;
  if (fileInput) {
    fileInput.value = '';
  }
}






  closeImportCsvModal() {

   if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }

  this.resetCsvImport();

    const modalEl = document.getElementById(this.importCsvModalId);
    if (!modalEl) return;

    modalEl.classList.add('hidden');
    modalEl.classList.remove('flex');
    modalEl.setAttribute('aria-hidden', 'true');



    setTimeout(() => {
      document.querySelectorAll('[modal-backdrop]').forEach(el => el.remove());
    document.querySelectorAll('.bg-gray-900.bg-opacity-50').forEach(el => el.remove());

    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.classList.remove('overflow-hidden');

      if (typeof initFlowbite === 'function') {
        initFlowbite();
      }
    }, 350);




  }









   filterTable(event: Event): void {
    this.searchQuery = (event.target as HTMLInputElement).value;
    this.tablePage = 1;
  }

  get visibleRows(): Beneficiaire[] {
    const q = this.searchQuery.trim().toLowerCase();
    if (!q) return this.data;
    return this.data.filter((row: any) =>
      [row.lastName, row.firstName, row.email, row.phoneNumber, row.role]
        .filter((v) => v !== undefined && v !== null)
        .join(' ').toLowerCase().includes(q),
    );
  }

  get tableTotalPages(): number { return Math.max(1, Math.ceil(this.visibleRows.length / this.tablePageSize)); }
  get tablePages(): number[] { return Array.from({ length: this.tableTotalPages }, (_, i) => i + 1); }
  get pagedRows(): Beneficiaire[] {
    const start = (this.tablePage - 1) * this.tablePageSize;
    return this.visibleRows.slice(start, start + this.tablePageSize);
  }
  tableGoTo(page: number): void { this.tablePage = Math.min(Math.max(1, page), this.tableTotalPages); }

  isChecked(row: any): boolean { return this.checkedRows.includes(row); }

  get allPageChecked(): boolean {
    return this.pagedRows.length > 0 && this.pagedRows.every((r) => this.isChecked(r));
  }

  toggleRow(row: any): void {
    this.checkedRows = this.isChecked(row)
      ? this.checkedRows.filter((r) => r !== row)
      : [...this.checkedRows, row];
    this.onRowSelect({ selected: this.checkedRows });
  }

  toggleAllPage(): void {
    const page = this.pagedRows;
    this.checkedRows = this.allPageChecked
      ? this.checkedRows.filter((r) => !page.includes(r))
      : [...this.checkedRows, ...page.filter((r) => !this.isChecked(r))];
    this.onRowSelect({ selected: this.checkedRows });
  }

  /** Actions de la barre de sélection : on repart toujours des cases cochées */
  chargeChecked(): void {
    this.selectedRows = [...this.checkedRows];
    this.isMulti = this.selectedRows.length > 1;
    this.chargeSelectedRows();
  }

  deleteChecked(): void {
    this.selectedRows = [...this.checkedRows];
    this.isMulti = this.selectedRows.length > 1;
    this.showDelete();
  }

  isInactive(row: any): boolean { return row?.mustChangePassword === true; }

  trackByEmail(_: number, row: any): string { return row?.email; }

  getChargeTitle() {
    return 'Charge';
  }

  updateSettings() {
    let title = this.getChargeTitle();
    this.settings = {
      selectMode: 'multi',
      actions: {
        columnTitle: '',
        position: 'right',
        add: false,
        edit: false,
        delete: false,
      },
      columns: {
        lastName: {
          title: tableHeaders.lastName,
          filter: false,
        },
        firstName: {
          title: tableHeaders.firstName,
          filter: false,
        },
        phoneNumber: {
          title: tableHeaders.phoneNumber,
          filter: false,
        },
        email: {
          title: tableHeaders.email,
          filter: false,
        },
        role: {
          title: tableHeaders.role,
          filter: false,
        },
        status: {
          title: tableHeaders.status,
          filter: false,
          type: 'html',
          // On remplace 'value' par 'row' pour accéder aux données de l'employé
          valuePrepareFunction: (value: any, row: Beneficiaire) => {
            // Si mustChangePassword est true, il n'a pas encore fait sa première connexion
            if (row.mustChangePassword === true) {
              return 'Inactif';
            } else {
              return 'Actif';
            }
          }
        },
         /* status: {
      title: tableHeaders.status,
      filter: false,
      type: 'html',
      valuePrepareFunction: (_: any, row: any) => {
        return row.mustChangePassword ? 'Inactif' : 'Actif';
      }
    },*/
        actions: {
          title: tableHeaders.actions,
          filter: false,
          type: 'custom',
          renderComponent: CustomActionComponent,
          onComponentInitFunction: (instance: CustomActionComponent) => {
            instance.charge.subscribe((rowData: any) =>
              this.handleCharge(rowData)
            );
            instance.delete.subscribe((rowData: any) =>
              this.handleDelete(rowData)
            );
          },


        },
      },
    };
  }
  handleCharge(rowData: any) {
    this.selectedRows = [rowData];
    this.showCharge();
  }
  showCharge() {
    // Use the trigger button to show the modal
    const triggerButton = document.getElementById('charge-modal-trigger');
    if (triggerButton) {
      triggerButton.click();
    } else {
      console.error(
        `Trigger button for modal '${this.chargeModalId}' not found.`
      );
    }
  }
 handleDelete(rowData: any) {
  this.selectedRows = [rowData];
  this.isMulti = false;
  this.showDelete();
}

  showDelete() {
    // Use the trigger button to show the modal
    const triggerButton = document.getElementById('delete-modal-trigger');
    if (triggerButton) {
      triggerButton.click();
    } else {
      console.error(
        `Trigger button for modal '${this.deleteModalId}' not found.`
      );
    }
  }

  handleBeneficiaireSubmit(formData: any): void {
    this.addBeneficiaire(formData);
  }

 private cleanupFlowbiteModal(modalId: string): void {
    const modalEl = document.getElementById(modalId);
    if (!modalEl) return;

    modalEl.classList.add('hidden');
    modalEl.classList.remove('flex');
    modalEl.setAttribute('aria-hidden', 'true');


    setTimeout(() => {
      document.querySelectorAll('[modal-backdrop]').forEach(backdrop => {
        backdrop.remove();
      });


      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.classList.remove('overflow-hidden');


    const form = modalEl.querySelector('form');
    if (form) {
      form.reset();
    }




    const inputs = modalEl.querySelectorAll('input, select, textarea');
    inputs.forEach((input: any) => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
      } else {
        input.value = '';
      }
    });




      if (typeof initFlowbite === 'function') {
        initFlowbite();
      }
    }, 350);


  }

 addBeneficiaire(formData: any): void {
  const newBeneficiaire: BeneficiaireRequest = {
    ...formData,
    companyId: this.companyId,
  };
  this.beneficiaireService.add(newBeneficiaire).subscribe({
    next: (response: any) => {


      this.loadEmployes();


      this.messageService.add({
        severity: 'success',
        summary: 'Succès',
        detail: 'Bénéficiaire ajouté avec succès.',
      });

       this.cleanupFlowbiteModal(this.addBeneficiaireModalId);
    },

      // --- Close the modal ---
     /* const modalElement = document.getElementById(
        this.addBeneficiaireModalId
      );
      if (modalElement) {
        try {
          const modal = new Modal(modalElement);
          modal.hide();

          const backdrop = document.querySelector('[modal-backdrop]');
          if (backdrop) {
            backdrop.remove();
          }
          document.body.style.overflow = '';
        } catch (e) {
          console.error('Error hiding modal programmatically:', e);
        }
      } else {
        console.warn(
          `Modal element with ID '${this.addBeneficiaireModalId}' not found.`
        );
      }
    },*/

    error: (err: any) => {
      console.error('Error adding beneficiary:', err);

      // ✅ Extraire le message express-validator
      if (err.status === 400 && err.error?.errors?.length > 0) {
        const errorMsg = err.error.errors.map((e: any) => e.msg).join(', ');
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: errorMsg,
        });
      } else {
        this.showError(err.status);
      }
    },
  });
}

  onRowSelect(event: { selected: any[] }) {
    this.selectedRows = event.selected;
    this.isMulti = this.selectedRows.length > 1;
   // console.log(this.selectedRows);
  }

  chargeSelectedRows() {
    if (this.selectedRows.length > 0) {
      this.showCharge();
    }


  }

deleteSelected() {
  if (this.selectedRows.length === 0) return;



  const emailsToDelete = this.selectedRows.map(employee => employee.email);


  this.isDeleting = true;

  const deleteRequests = emailsToDelete.map(email =>
    this.beneficiaireService.removeEmployee(email)
  );

  forkJoin(deleteRequests).subscribe({
    next: (results) => {
      this.isDeleting = false;
      //console.log('Résultats des suppressions:', results);

      const successCount = results.filter(r =>
        r.message?.includes('succès') || r.statusCode === 200
      ).length;


      const failCount = emailsToDelete.length - successCount;


      if (successCount > 0) {
        this.messageService.add({
          severity: failCount > 0 ? 'warn' : 'success',
          summary: failCount > 0 ? 'Succès partiel' : 'Succès',
          detail: failCount > 0
            ? `${successCount} supprimé(s), ${failCount} échec(s)`
            : `${successCount} bénéficiaire(s) supprimé(s) avec succès`,
        });
      }


      // Recharger les données
      this.loadEmployes();


      // Vider la sélection APRÈS le rechargement
      this.clearSelection();
    },
    error: (error) => {
      this.isDeleting = false;
      console.error('Erreur lors de la suppression:', error);


      let errorDetail = 'Erreur lors de la suppression';


      if (error.status === 404) {
        errorDetail = 'Bénéficiaire introuvable';
      } else if (error.status === 401) {
        this.authService.logout();
        this.router.navigate([RoutesEnum.signinRoute]);
        errorDetail = 'Session expirée, veuillez vous reconnecter';
      } else if (error.status === 500) {
        errorDetail = 'Erreur serveur. Veuillez réessayer plus tard';
      }


      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: errorDetail,
      });


      // Vider la sélection même en cas d'erreur
      this.clearSelection();
    }
  });
}

onConfirmDelete() {
  this.deleteSelected();
}








  onCancel() {
  this.resetChargeForm();
  this.clearSelection();
}

  clearSelection() {
  this.selectedRows = [];
  this.isMulti = false;
  this.checkedRows = [];}




  onConfirmTransfer() {
    if (this.selectedRows.length === 0) return;
    this.selectedRows.forEach((row) => {
      this.transferTicketToRow(this.account, row.walletAddress);
    });
     this.clearSelection();
  }

  private transferTicketToRow(account: string, walletAddress: string) {
    this.beneficiaireService
      .transferTickets(
        account,
        walletAddress,
        this.idTicket,
        this.amounToTransfer
      )
      .subscribe({
        next: () => {
          this.showSuccess('Chargement effectué avec succès');
          this.resetChargeForm();
          this.loadUserCompanyId();
        },
        error: (err) => {
          console.error('Error transferring tickets:', err);
          this.showError(err.status);
          this.resetChargeForm();
        },
      });
  }

  private showError(status: number): void {
    let detail = "Une erreur est survenue lors de l'ajout du bénéficiaire.";

    switch (status) {
      case 400:
        detail =
          'Requête invalide. Veuillez vérifier les champs du formulaire.';
        break;
      case 401:
        detail = 'Non autorisé. Veuillez vous reconnecter.';
        break;
      case 403:
        detail = "Accès refusé. Vous n'avez pas les droits nécessaires.";
        break;
      case 404:
        detail = 'Service introuvable. Veuillez réessayer plus tard.';
        break;
      case 409:
        detail = 'Conflit : un bénéficiaire avec ces informations existe déjà.';
        break;
      case 500:
        detail = 'Erreur interne du serveur. Merci de réessayer plus tard.';
        break;
      case 99:
        detail = 'Votre solde est insufissant !';
        break;
      default:
        detail = 'Une erreur inattendue est survenue.';
    }

    this.messageService.add({
      severity: 'error',
      summary: 'Erreur',
      detail,
    });
  }

  private showSuccess(detail: string) {
    this.messageService.add({
      severity: 'success',
      summary: 'Succès',
      detail,
    });
  }

  private resetChargeForm() {
    this.chargeForm.reset({ days: null });
  }

  ngAfterViewInit(): void {
    // Add a small delay to ensure DOM is fully ready
    setTimeout(() => {
      if (typeof initFlowbite === 'function') {
        initFlowbite();
      } else {
        console.error(
          'initFlowbite function not found. Make sure Flowbite JS is loaded.'
        );
      }
    }, 50); // 50ms delay, can adjust if needed
  }
}

// Fonction de validation personnalisée
function positiveNumberValidator(
  control: FormControl
): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined) return null;
  return value > 0 ? null : { notPositive: true };
}
